import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieUtilWrapperService {
  host: string;

  constructor(private cookieService: CookieService) {
    this.host = window.location.hostname.split('.')[0];
  }

  get(key: string): string {
    return this.cookieService.get(this.getLocalKey(key));
  }

  set(
    key: string,
    value: string,
    expires?: number | Date,
    path?: string,
  ): void {
    this.cookieService.set(
      this.getLocalKey(key),
      value,
      expires,
      path,
      window.location.hostname,
    );
  }

  delete(key: string, path?: string): void {
    this.cookieService.delete(
      this.getLocalKey(key),
      path,
      window.location.hostname,
    );
  }

  getLocalKey(key: string) {
    return `${this.host}_${key}`;
  }
}
